/*
  Unified Fields Props Definition
*/
import {FormattedMessage} from "react-intl"
import React from "react"

import moment from "moment"

export default {
	load() {
		return {
			fields: {
				provider_id: {
					label: <FormattedMessage id="Patient.form.patientrequest.orgunit" />,
					rules: "string"
				},
				identifier: {
					label: <FormattedMessage id="Patient.labels.IDNumber" />,
					rules: "string"
				},
				validity_from: {
					value: moment()
						.startOf("month")
						.format("YYYY-MM-DD")
				},
				validity_to: {
					value: moment()
						.endOf("month")
						.format("YYYY-MM-DD")
				}
			}
		}
	}
}
